import script from "./ImageClipHandler.vue?vue&type=script&lang=ts&setup=true"
export * from "./ImageClipHandler.vue?vue&type=script&lang=ts&setup=true"

import "./ImageClipHandler.vue?vue&type=style&index=0&id=3e0199ec&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e0199ec"]])

export default __exports__